import * as XLSX from "xlsx";

export interface ProductFisicoRow {
  product_id: string;
  sku: string | null;
  product_name: string;
  unit: string | null;
  fisico: number; // físico (bodega) = products.stock
  no_despachado: number; // facturado no despachado
  disponible: number; // disponible para la venta
}
import type { OilType, RawMaterial } from "~/types/purchasing";

export type Plant = "P1" | "P2";

export const PLANT_LABEL: Record<Plant, string> = {
  P1: "Planta 1",
  P2: "Planta 2",
};

export interface InsumoStockRow {
  kind: "oil" | "raw_material";
  id: string;
  code: string;
  name: string;
  unit: string;
  plant: Plant;
  stock: number;
  minimumStock: number | null;
  oil?: OilType;
  material?: RawMaterial;
}

const formatDate = () => new Date().toISOString().split("T")[0];

const insumosToSheet = (rows: InsumoStockRow[]) =>
  rows.map((r) => ({
    Código: r.code,
    Nombre: r.name,
    Unidad: r.unit,
    Planta: PLANT_LABEL[r.plant],
    Stock: r.stock,
    "Stock mínimo": r.minimumStock ?? "",
  }));

const materiaPrimaToSheet = (rows: InsumoStockRow[]) =>
  rows.map((r) => ({
    Código: r.code,
    Nombre: r.name,
    Unidad: r.unit,
    Planta: PLANT_LABEL[r.plant],
    Stock: r.stock,
    "Stock mínimo": r.minimumStock ?? "",
  }));

const productsToSheet = (rows: ProductFisicoRow[]) =>
  rows.map((r) => ({
    SKU: r.sku ?? "",
    Producto: r.product_name,
    Unidad: r.unit ?? "",
    "Stock físico": r.fisico,
    "Facturado no despachado": r.no_despachado,
    "Disponible para la venta": r.disponible,
  }));

const appendSheet = (
  workbook: XLSX.WorkBook,
  name: string,
  data: Record<string, unknown>[]
) => {
  const sheet = XLSX.utils.json_to_sheet(
    data.length > 0 ? data : [{ "Sin datos": "" }]
  );
  XLSX.utils.book_append_sheet(workbook, sheet, name);
};

export function exportInsumosTab(rows: InsumoStockRow[]) {
  const workbook = XLSX.utils.book_new();
  appendSheet(workbook, "Insumos", insumosToSheet(rows));
  XLSX.writeFile(workbook, `stock_insumos_${formatDate()}.xlsx`);
}

export function exportMateriaPrimaTab(rows: InsumoStockRow[]) {
  const workbook = XLSX.utils.book_new();
  appendSheet(workbook, "Materia Prima", materiaPrimaToSheet(rows));
  XLSX.writeFile(workbook, `stock_materia_prima_${formatDate()}.xlsx`);
}

export function exportProductsTab(rows: ProductFisicoRow[]) {
  const workbook = XLSX.utils.book_new();
  appendSheet(workbook, "Productos Terminados", productsToSheet(rows));
  XLSX.writeFile(workbook, `stock_productos_terminados_${formatDate()}.xlsx`);
}

export function exportAll(
  insumos: InsumoStockRow[],
  materiaPrima: InsumoStockRow[],
  products: ProductFisicoRow[]
) {
  const workbook = XLSX.utils.book_new();
  appendSheet(workbook, "Insumos", insumosToSheet(insumos));
  appendSheet(workbook, "Materia Prima", materiaPrimaToSheet(materiaPrima));
  appendSheet(workbook, "Productos Terminados", productsToSheet(products));
  XLSX.writeFile(workbook, `stock_consolidado_${formatDate()}.xlsx`);
}
